import { Link as RouterLink } from 'react-router-dom';
import styles from './link.module.scss';
import clsx from 'clsx';
import { HTMLAttributeAnchorTarget, MouseEventHandler } from 'react';
import { OpenInNewWindowIcon } from '../OpenInNewWindowIcon/OpenInNewWindowIcon';

type LinkProps = {
  className?: string;
  href?: string;
  text: string;
  onClick?: () => void;
  target?: HTMLAttributeAnchorTarget | undefined;
  showExternalLinkIcon?: boolean;
  'data-testid'?: string;
};

export const Link = ({
  className,
  href,
  text,
  onClick,
  target,
  showExternalLinkIcon = false,
  'data-testid': dataTestId,
}: LinkProps) => {
  const handleClick: MouseEventHandler<HTMLAnchorElement> = e => {
    if (onClick) {
      e.preventDefault();
      onClick();
    }
  };

  // If external link or has target, use regular anchor tag
  if (target || href?.startsWith('http')) {
    return (
      <a
        className={clsx(styles.link, className)}
        href={href || ''}
        onClick={handleClick}
        target={target}
        rel={target === '_blank' ? 'noopener noreferrer' : undefined}
        data-testid={dataTestId}
      >
        {text}
        {showExternalLinkIcon && <OpenInNewWindowIcon />}
      </a>
    );
  }

  // Internal link, use React Router Link
  return (
    <RouterLink
      className={clsx(styles.link, className)}
      to={href || ''}
      onClick={handleClick}
      data-testid={dataTestId}
    >
      {text}
      {showExternalLinkIcon && <OpenInNewWindowIcon />}
    </RouterLink>
  );
};
